export default "__VITE_ASSET__lYSejH7I__"